import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pricingApiConnect } from '../lib/api/pricingApi.connect';
export function useUpdatePricing(projectId, pricingId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data)=>pricingApiConnect.updatePricing(projectId, pricingId, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'pricing',
                    projectId,
                    pricingId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'pricing',
                    projectId
                ]
            });
            // Rate-card edits are written through SetPricingRate. Invalidate the
            // LCATs cache too so the LCAT tab stays in step.
            queryClient.invalidateQueries({
                queryKey: [
                    'lcats',
                    projectId
                ]
            });
        }
    });
}
